import {
    Box,
    Grid,
    Flex,
    Heading
} from '@theme-ui/components'
import { Container, Circle, Markdown } from '~/Common'
import { useTranslation } from 'react-i18next'

export const ProjectMilestones = ({ bg = 'white', data, container, ...props }) => {
    const { t } = useTranslation();
    const title = data?.title ?? null;
    const description = data?.description ?? null;
    const bottomDescription = data?.bottomDescription ?? null;
    const rows = data?.milestones ?? null;

    return (
        <Box bg={bg} {...props}>
            <Container variant="layouts.section" {...container}>
                { title && <Heading as="h2" variant="content_block_heading">{t(title)}</Heading>}
                { description && <Box className="markdown" mb={[3,3,4]}>
                    <Markdown>{description}</Markdown>
                </Box>}

                {rows &&
                    <Box sx={{
                        position: 'relative',
                        '&::before': {
                            content: '""',
                            bg: '#D5D9DA',
                            width: '1px',
                            position: 'absolute',
                            top: '40px',
                            bottom: 0
                        }
                    }}>
                        <Box sx={{
                            pl: '38px'
                        }}>
                            <Grid py={2} sx={{
                                gridGap: 4,
                                gridTemplateColumns: ['1fr 4fr'],
                                width: '100%',
                                fontSize: '14px',
                                color: '#6A7175'
                            }}>
                                <Box px={2}>Date</Box>
                                <Box px={2}>Milestone</Box>
                            </Grid>

                            <Box>
                                {rows.map((row, key) => (
                                    <Grid key={key} py={'23px'} sx={{
                                        gridGap: 4,
                                        rowGap: 0,
                                        gridTemplateColumns: ['1fr 4fr'],
                                        width: '100%',
                                        borderBottom: '1px solid #F7F8F9',
                                        bg: 'transparent'
                                    }}>
                                        <Flex sx={{
                                            marginTop: '8px',
                                            alignItems: 'center',
                                            left: '0',
                                            position: 'absolute',
                                            transform: 'translateX(-50%)'
                                        }}>
                                            <Circle
                                                type="box"
                                                size="8px"
                                                pulse={true}
                                                bg="darker"
                                            />
                                        </Flex>
                                        <Box px={2}>{row?.date}</Box>
                                        <Box px={2} sx={{
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word'
                                        }}>
                                            {row?.milestone}
                                        </Box>
                                    </Grid>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                }

                { bottomDescription && <Box mt={2} className="markdown">
                    <Markdown externalLinks={true}>{bottomDescription}</Markdown>
                </Box> }
            </Container>
        </Box>
    )
};
